/**
 * Corporate Theme - Main Entry Point
 * Focused on high-performance Vanilla JS and GSAP animations.
 */

// 1. Global Styles
import "../scss/style.scss";

// 2. Image Optimization (Lazysizes)
import "lazysizes";
import "lazysizes/plugins/rias/ls.rias";
import "lazysizes/plugins/parent-fit/ls.parent-fit";

// 3. Animation Engine
import { initScrollAnimations } from "./common/animation/scrollAnimations";

// 4. Prefetching
import { listen } from "quicklink";

// 5. Page Content Components (UPDATED PATHS)
import { initArchiveMasonry } from "./partials/PageContent/default/archiveMasonry";
import { initHeroSlider } from "./partials/PageContent/default/heroSlider";
import { initHeroBento } from "./partials/PageContent/default/heroBento";
import { initCtaSlider } from "./partials/PageContent/default/ctaSlider";
import { initCtaImageParallax } from "./partials/PageContent/default/ctaImage";
import { initArchiveShowcaseVideos } from "./partials/PageContent/default/archiveShowcase";
import { initArticleWSlider } from "./partials/PageContent/default/articleWSlider";
import { initCertificatesLightbox } from "./partials/PageContent/default/certificatesGrid";
import { initGalleryGrid } from "./partials/PageContent/default/galleryGrid";

// 6. Post/CPT Content Components
import { initVideoFacades } from "./partials/PostContent/default/video";
import { initGalleries } from "./partials/PostContent/default/gallery";
import { initAccordions } from "./partials/PostContent/default/accordion";

// 7. Contact Form
import { initContactForm } from "./templates/contact/contactForm";

// 8. Cookie Consent
import { initCookieConsent } from "./parts/footer/cookieConsent";

/**
 * Initialize all global and component-specific logic.
 */
const initGlobals = () => {
  // Initialize Scroll-Triggered Animations (GSAP)
  initScrollAnimations();

  // --- Page Section Initializers ---
  initArchiveMasonry();
  initHeroSlider();
  initHeroBento();
  initCtaSlider();
  initCtaImageParallax();
  initArchiveShowcaseVideos();
  initArticleWSlider();
  initCertificatesLightbox();
  initGalleryGrid();

  // --- Single Post/Service/Project Content Initializers ---
  initVideoFacades();
  initGalleries();
  initAccordions();

  // --- Contact Form Initializer ---
  initContactForm();

  initCookieConsent();

  // Start listening for in-viewport links to prefetch
  listen();

  console.log("[Main JS] Corporate Base initialized.");
};

// --- Bootstrap ---
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initGlobals);
} else {
  initGlobals();
}
